import { CoreModel } from '../core/core.model';
export class GaugeModel extends CoreModel {
/**
 * Maximum integer value of gauge
 */
max: number;
/**
 * Type value of gauge. Can be: full, arch, semi. Default is full.
 */
type: string;
/**
 * Aanimation duration of gauge in seconds
 */
size: number;
/**
 * Current integer value of gauge
 */
value: number;
/**
 * Label of gauge
 */
label: string;
/**
 * Prefix of gauge
 */
prefix: string;
/**
 * Suffix of gauge
 */
suffix: string;
/**
 * Able gauge to input it value
 */
inputValue: boolean;
/**
 * Size for width/height of gauge. It means number of pixels.
 */
animationDuration: number;
/**
 * It is the constructor for the gauge component. It takes the required string values to create the gauge object
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function GaugeModel_tsickle_Closure_declarations() {
/**
 * Maximum integer value of gauge
 * @type {?}
 */
GaugeModel.prototype.max;
/**
 * Type value of gauge. Can be: full, arch, semi. Default is full.
 * @type {?}
 */
GaugeModel.prototype.type;
/**
 * Aanimation duration of gauge in seconds
 * @type {?}
 */
GaugeModel.prototype.size;
/**
 * Current integer value of gauge
 * @type {?}
 */
GaugeModel.prototype.value;
/**
 * Label of gauge
 * @type {?}
 */
GaugeModel.prototype.label;
/**
 * Prefix of gauge
 * @type {?}
 */
GaugeModel.prototype.prefix;
/**
 * Suffix of gauge
 * @type {?}
 */
GaugeModel.prototype.suffix;
/**
 * Able gauge to input it value
 * @type {?}
 */
GaugeModel.prototype.inputValue;
/**
 * Size for width/height of gauge. It means number of pixels.
 * @type {?}
 */
GaugeModel.prototype.animationDuration;
}

